export default __webpack_public_path__ + "static/media/2021 spice rack side.d547731f.png";